import { useState } from "react";
import { faqs } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="想了解腐漫网？这里都有答案"
          desc="关于社区使用、内容规范与入坑指南的常见疑问，集中为你解答。"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="flex-1 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.q}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-500"
                    }`}
                  >
                    <i className={`ri-arrow-down-s-line text-lg transition-transform ${isOpen ? "rotate-180" : ""}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}